import React from 'react';
import loadable from '@wix/yoshi-flow-editor/loadable';
import Loader from '../../../common/components/loader';

export default loadable(
  () => import(/* webpackChunkName: "rich-content-viewer" */ './ricos-viewer'),
  { fallback: <Loader /> },
);
